module.exports = __webpack_public_path__ + "img/Objet dynamique vectoriel4-03.e8218011.png";